import React, {useContext} from "react";
import "./Footer.css";
import {Fade} from "react-reveal";
// import emoji from "react-easy-emoji";
// Commented this out because emojis arent working until "https://github.com/twitter/twemoji" fixes their extensions. Everywhere you see an emoji commented out is where I made the change as of 02/08/2023

import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {/* {emoji("Made with ❤️ by Pledge")} */}
          {("Made with ❤️ by Pledge")}
        </p>
      </div>
    </Fade>
  );
}
